import type { Slot } from '../Model/Slot';

/** 인라인 저장 시 서버·검색과 직결된 필드 — 낙관적 반영하지 않음 */
const INLINE_SENSITIVE_KEYS: (keyof Slot)[] = [
  'main_keyword',
  'word_keyword',
  'mid_single',
  'mid_compare',
  'product_url',
  'compare_url',
  'user',
];

export function isOptimisticInlineDto(dto: Partial<Slot>): boolean {
  const keys = Object.keys(dto).filter((k) => {
    const v = dto[k as keyof Slot];
    return v !== undefined && v !== null;
  });
  if (keys.length === 0) return false;
  return keys.every((k) => !INLINE_SENSITIVE_KEYS.includes(k as keyof Slot));
}
